import type { JSX } from 'react';

import { TableColumn } from '../../enums/TableColumn';
import { TimeLineContainer } from '../cells/TimeLine.container';

export const TableHeadCellStateChanges = (): JSX.Element => (
    <th
        style={{ width: '50%' }}
        className={'force-overflow-visible padding-20 padding-bottom-10 padding-top-2'}
        key={TableColumn.STATE_CHANGES}
    >
        <span>
            <span>
                <TimeLineContainer />
            </span>
        </span>
    </th>
);
